export function formatCryptoAddressOrTx(addressOrTx: string, network?: string): string {
  const trimmedAddressOrTx = addressOrTx.trim();
  const isBitcoinOrTron = network === 'BTC' || network === 'TRC';
  return isBitcoinOrTron || addressOrTx.startsWith('0x') ? trimmedAddressOrTx : `0x${trimmedAddressOrTx}`;
}
